import { QuestionTooltipProps } from "component-library";

export type AgencyForm = {
  agencyName: string;
  email: string;
  phone: string;
  webSite?: string;
  address?: string;
  postCode?: string;
};

export type AgencyFormKeys = keyof AgencyForm;

export interface IAddNewAgencyFormContent {
  form: AgencyFormContent;
  validation: {
    agencyName: {
      required: string;
      maxLength: string;
    };
    email: {
      email: string;
      required: string;
      maxLength: string;
    };
    phone: {
      required: string;
      maxLength: string;
    };
    webSite: {
      maxLength: string;
    };
    address: {
      maxLength: string;
    };
    postCode: {
      maxLength: string;
    };
  };
  help: {
    agencyName: QuestionTooltipProps;
    webSite: QuestionTooltipProps;
  };
}

export type AgencyFormContent = {
  [T in AgencyFormKeys]: string;
};

export type AgencyFormValidation = {
  [T in AgencyFormKeys]: {
    invalid: boolean;
    validationMessage: string;
  };
};

export const AGENCY_TO_FORM_MAPPING = {
  name: "agencyName",
  email: "email",
  phone: "phone",
  website: "webSite",
  streetAddress: "address",
  postcode: "postCode",
};

export const FORM_TO_AGENCY_MAPPING = {
  agencyName: "name",
  email: "email",
  phone: "phone",
  webSite: "website",
  address: "streetAddress",
  postCode: "postcode",
};
